/**
 * GeoJSON ↔ Leaflet coordinate order, in one place.
 *
 * GeoJSON writes `[lng, lat]` and Leaflet takes `[lat, lng]`. Getting it the
 * wrong way round does not throw — it puts the farm in the sea — so every map
 * that reads a stored boundary converts through here rather than reimplementing
 * the swap and its own chance of transposing it.
 */

import type L from 'leaflet';
import type { GeoJSONPolygon } from '../types/orchard';

/** GeoJSON `[lng, lat]` ring → Leaflet `[lat, lng][]`. */
export function geoJsonRingToLatLng(ring: number[][]): [number, number][] {
  return ring.map(([lng, lat]) => [lat, lng]);
}

/**
 * A drawn Leaflet layer's geometry, or null.
 *
 * Swallows rather than throws: this runs inside a leaflet-draw event handler,
 * where an exception takes the draw control down with it and leaves the map in
 * a mode nothing can cancel.
 */
export function leafletLayerToGeoJson(layer: L.Layer): GeoJSONPolygon | null {
  try {
    const geojson = (layer as unknown as { toGeoJSON?: () => { geometry?: GeoJSONPolygon } })
      .toGeoJSON?.();
    return geojson?.geometry ?? null;
  } catch {
    return null;
  }
}
